import { useEffect, useRef, useState } from "react";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import { Link } from "react-router-dom";
import { ReactComponent as ChatIcon } from "../../assets/SideBar/chatIcon.svg";
import { ReactComponent as CompaniesIcon } from "../../assets/SideBar/comanies.svg";
import { ReactComponent as CourseIcon } from "../../assets/SideBar/course.svg";
import { ReactComponent as DashboardIcon } from "../../assets/SideBar/dashboard.svg";
import { ReactComponent as DollarIcon } from "../../assets/SideBar/dollar.svg";
import { ReactComponent as EducationIcon } from "../../assets/SideBar/education.svg";
import { ReactComponent as PackageIcon } from "../../assets/SideBar/package.svg";
import { ReactComponent as Posts } from "../../assets/SideBar/posts.svg";
import { ReactComponent as QuizIcon } from "../../assets/SideBar/quiz.svg";
import { ReactComponent as SettingsIcon } from "../../assets/SideBar/settings.svg";
import { ReactComponent as SessionsIcon } from "../../assets/SideBar/swarm-session.svg";
import { ReactComponent as UsersIcon } from "../../assets/SideBar/users.svg";
import { ReactComponent as WebinarsIcon } from "../../assets/SideBar/webinar.svg";
import { ReactComponent as SubscriptionsIcon } from "../../assets/Subscriptions/subscriptions.svg";
import "./SideBar.css";

// TODO: add routing to the tools
const toolGroups = [
  {
    name: "User Management",
    tools: [
      {
        icon: <UsersIcon width={20} height={20} />,
        name: "Users",
        route: "/users",
      },
      {
        icon: <ChatIcon width={20} height={20} />,
        name: "Chat",
        route: "/chat",
      },
      {
        icon: <SessionsIcon width={20} height={20} />,
        name: "Sessions",
        route: "/sessions",
      },
      {
        icon: <DollarIcon width={20} height={20} />,
        name: "Withdrawals",
        route: "/withdrawals",
      },
    ],
  },
  {
    name: "Specialists Management",
    tools: [
      {
        icon: <UsersIcon width={20} height={20} />,
        name: "Specialists",
        route: "/specialists",
      },
      {
        icon: <UsersIcon width={20} height={20} />,
        name: "Review Queue",
        route: "/review-specialists",
      },
      {
        icon: <Posts width={20} height={20} />,
        name: "Posts",
        route: "/posts",
      },
      {
        icon: <EducationIcon width={20} height={20} />,
        name: "Certificates",
        route: "/certificates",
      },
      {
        icon: <PackageIcon width={20} height={20} />,
        name: "Session packages",
        route: "/session-packages",
      },
      {
        icon: <WebinarsIcon width={20} height={20} />,
        name: "Webinars",
        route: "/webinars",
      },
      {
        icon: <CourseIcon width={20} height={20} />,
        name: "Courses",
        route: "/courses",
      },
      {
        icon: <MenuBookOutlinedIcon fontSize="small" />,
        name: "Publications",
        route: "/publications",
      },
      {
        icon: <EducationIcon width={20} height={20} />,
        name: "Educational Hubs",
        route: "/educational-hubs",
      },
    ],
  },
  {
    name: "Companies Management",
    tools: [
      {
        icon: <CompaniesIcon width={20} height={20} />,
        name: "Companies",
        route: "/companies",
      },
    ],
  },
  {
    name: "Platform",
    tools: [
      {
        icon: <DashboardIcon width={20} height={20} />,
        name: "Dashboard",
        route: "/dashboard",
      },
      {
        icon: <SubscriptionsIcon width={20} height={20} />,
        name: "FlexPass",
        route: "/flexpass",
      },
      {
        icon: <SettingsIcon width={20} height={20} />,
        name: "Settings",
        route: "/other-settings",
      },
      {
        icon: <SettingsIcon width={20} height={20} />,
        name: "Meta Data",
        route: "/metadata",
      },
      {
        icon: <QuizIcon width={20} height={20} />,
        name: "System Quizzes",
        route: "/system-quizzes",
      },
    ],
  },
];

const AllToolsPopup = ({ onClose }: { onClose: () => void }) => {
  const popupRef = useRef<HTMLDivElement>(null);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(e.target as Node)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    const searchInput = popupRef.current?.querySelector("input");
    searchInput?.focus();

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="tools-popup" ref={popupRef}>
      <div className="search-box">
        <SettingsIcon className="search-icon" />
        <input
          type="text"
          placeholder="Search tools"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <div className="tool-groups">
        {toolGroups.map((group) => {
          const filtered = group.tools.filter((tool) =>
            tool.name.toLowerCase().includes(search.toLowerCase()),
          );
          if (filtered.length === 0) return null;

          return (
            <div
              key={group.name}
              className="tool-group"
              role="group"
              aria-label={group.name}
            >
              <div className="group-title">{group.name}</div>
              {filtered.map((tool) => (
                <Link to={tool.route} key={tool.route}>
                  <div className="search-item">
                    {tool.icon}
                    <span>{tool.name}</span>
                  </div>
                </Link>
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AllToolsPopup;
